"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.qametsQ = void 0;
var qQsnippets = [
    "ʾāzǝn",
    "ʾākǝl",
    "ʾākǝl",
    "ʾāniyּ",
    "ʾāpǝn",
    "ʾārǝḥ",
    "ʾārǝkּ",
    "ʾāšǝr",
    "bāʾǝš",
    "bāšǝtּ",
    "bּāšǝtּ",
    "gābǝh",
    "gּābǝh",
    "gādǝl",
    "gּādǝl",
    "gārǝn",
    "gּārǝn",
    "ḥādǝš",
    "ḥākǝm",
    "ḥālǝyֽwō",
    "ḥālǝyōw",
    "ḥānּēniy",
    "ḥāpǝn",
    "ḥāpǝniy",
    "ḥāpǝšiy",
    "ḥāpǝšiyt",
    "ḥāq-",
    "ḥārǝb",
    "ḥārǝneper",
    "ḥārǝpּ",
    "ḥāšǝkּ",
    "yāpǝy",
    "yāšǝr",
    "kāl-",
    "kּāl-",
    "mār-",
    "mārǝdּǝkay",
    "mātǝn",
    "sālǝtּ",
    "ʿāzּ",
    "ʿāmǝriy",
    "ʿānǝy",
    "ʿāpǝr",
    "ʿārǝl",
    "ʿārǝpּ",
    "ʿāšǝr",
    "ṣārǝkּ",
    "qādǝq",
    "qādǝš",
    "qārǝbּ",
    "qārǝḥ",
    "rāb-",
    "rāgǝz",
    "rāḥǝbּ",
    "šārǝš",
    "šārāš",
    "šּārāš",
    "tּākǝniyt",
    "tām-",
    "tּām-"
];
var qQRgx = qQsnippets.map(function (snippet) { return new RegExp(snippet, "m"); });
var qametsQatanDict = {
    // for certain inflected and contextual occurences
    bּǝʾābǝdan: "bǝʾobdan",
    hāʾābǝnāyim: "hāʾobnāyim",
    ḥāqǝkā: "ḥoqkā",
    ḥāqǝkem: "ḥoqkem",
    hadּārǝbāֽn: "haddorbān",
    lǝʾākǝlāֽh: "lǝʾoklāh",
    haqּārǝbāֽn: "haqqorbān",
    ḥāpǝraʿ: "ḥopraʿ",
    wayּāmāt: "wayּāmot",
    wayּānās: "wayּānos",
    wayּāqām: "wayּāqom",
    wayּārām: "wayּārām",
    wayּāšׁāb: "wayּāšׁob",
    watּāmāt: "watּāmot",
    watּāqām: "watּāqom",
    watּāšׁāb: "watּāšׁob",
    wǝhāֽʿāpǝniy: "wǝhāʿopniy",
    tּākǝniֽyt: "tokniyt" // with silluq
};
exports.qametsQ = function (text) {
    return text.map(function (word) {
        var e_1, _a;
        //   if there is no qamets char, return
        if (!/ā/.test(word)) {
            return word;
        }
        if (qametsQatanDict[word]) {
            return qametsQatanDict[word];
        }
        if (/ŏ/.test(word)) {
            var pos = word.indexOf("ŏ");
            if (word.charAt(pos - 2) === "ā") {
                return word.substring(pos - 2) + "o" + word.substring(pos - 1);
            }
        }
        try {
            for (var qQRgx_1 = __values(qQRgx), qQRgx_1_1 = qQRgx_1.next(); !qQRgx_1_1.done; qQRgx_1_1 = qQRgx_1.next()) {
                var rgx = qQRgx_1_1.value;
                if (rgx.test(word)) {
                    var newRgx = rgx.source.split("ā").join("o");
                    var matches = rgx.source.match(/ā/g);
                    // checks for qQ forms w/ two ā's
                    if (matches && matches.length >= 2) {
                        var parts = rgx.source.split("ā");
                        var firstMatch = [parts.shift(), parts.join("ā")];
                        newRgx = firstMatch.join("o");
                    }
                    return word.split(rgx).join(newRgx);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (qQRgx_1_1 && !qQRgx_1_1.done && (_a = qQRgx_1.return)) _a.call(qQRgx_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return word;
    });
};
//# sourceMappingURL=qametsQatan.js.map